import PaginationComponent from '@/components/common/PaginationComponent';
import QuestionsSkeleton from '@/components/molecules/question-list/QuestionsSkeleton';
import QuestionItem from '@/components/molecules/question-list/question-item';
import { ROUTES } from '@/types/common';
import Link from 'next/link';
import useRealtimeWebQnaViewModel from '../view-models/useRealtimeWebQnaViewModel';

const RealtimeWebQna = () => {
  const viewModel = useRealtimeWebQnaViewModel();
  return (
    <>
      {viewModel.isQnaListLoading ? (
        <QuestionsSkeleton />
      ) : (
        <ul>
          {viewModel.questions.map((qna) => (
            <li key={`qna-${qna.question.questionPid}`}>
              <Link href={`${ROUTES.QNA.DETAIL.path}/${qna.question.questionPid}`}>
                <a>
                  <QuestionItem questionCard={qna} onClickQuestion={() => {}} />
                </a>
              </Link>
            </li>
          ))}
        </ul>
      )}
      <PaginationComponent
        totalPage={viewModel.totalPage}
        queries={viewModel.queries}
        baseUrl={ROUTES.QNA.REALTIME.path}
        currentPage={Number(viewModel.queries.page)}
        scroll={false}
        scrollRestoration={true}
      />
    </>
  );
};

export default RealtimeWebQna;
